import { normalizeString } from '@/utils/index';
import { verifyValueBasedOnRegExes } from '@/utils/phone';
import { countriesPhoneDataByDDI } from '@/utils/phone/countries';
import { Mask } from 'maska';
import { phone as phoneLibrary } from 'phone';

export class Phone {
	private phone: string = '';

	constructor(phone: string) {
		if (phone) {
			this.phone = phone;
		}
	}

	private getNormalizedPhone(): string {
		return normalizeString(this.phone, ['+']);
	}

	updatePhone(phone: string): void {
		this.phone = phone;
	}

	getCompletePhone(): string {
		const code = this.getCode();
		const phone = this.getPhone();

		return `${code}${phone}`;
	}

	getPhone(): string {
		const code = this.getCode();

		const phone = this.getNormalizedPhone().replace(code || '', '');

		return phone;
	}

	getDDI(): string | null {
		if (!this.phone.includes('+')) {
			return null;
		}

		const normalizedPhone = this.getNormalizedPhone();

		return phoneLibrary(normalizedPhone, {
			validateMobilePrefix: false
		}).countryIso2;
	}

	getCode(): string | null {
		const DDI = this.getDDI() || '';

		return countriesPhoneDataByDDI[DDI]?.code || null;
	}

	getFormattedPhone(): string {
		const phone = this.getPhone();
		const DDI = this.getDDI();

		if (!DDI) {
			return phone;
		}

		const mask = countriesPhoneDataByDDI[DDI]?.mask || [];

		const maska = new Mask({ mask });

		return maska.masked(phone);
	}

	isValid(): boolean {
		const DDI = this.getDDI();

		if (!DDI) {
			return false;
		}

		const masks = countriesPhoneDataByDDI[DDI]?.mask || [];
		const phone = this.getFormattedPhone();

		return verifyValueBasedOnRegExes(masks, phone);
	}
}
